import React, { useRef, useState, useEffect } from "react"
import Recorder from "../misc/Recorder"

// set len of test record (for progress bar)
const RECORD_LEN = 30

// modal version
export default function SelfMicCheckModal(props) {
    const recorderRef = useRef(null)
    const [recommendation, setRecommendation] = useState("")
    const [progress, setProgress] = useState(0)
    const [delay, setDelay] = useState(null)
    const [params, setParams] = useState({})

    const handleRecord = (url, blob, streamSettings, analysis) => {
        setParams({ ...streamSettings, url: url, blob: blob })

        if ((analysis.normal / analysis.total) * 100 > 70) {
            setRecommendation("All is ok")
        } else if ((analysis.silent / analysis.total) * 100 > 30) {
            setRecommendation("You need to add sensitivity to the microphone")
        } else if ((analysis.clip / analysis.total) * 100 > 30) {
            setRecommendation("You need to turn down the sensitivity of the microphone")
        }
    }

    useEffect(() => {
      if (recommendation !== "") {
        props.eventHandler.onFinish(recommendation, params);
      }
    }, [recommendation, params]);
    

    const onStart = () => {
        setProgress(0)
        setDelay((RECORD_LEN / 100) * 1000)
    }
    const onStop = () => {
        setDelay(null)
    }
    return (
      <>
        <Recorder
          ref={recorderRef}
          onChange={handleRecord}
          controlsSize={2}
          onStart={onStart}
          onStop={onStop}
          withoutPause
          oneButton
          analysis
          eventHandler={props.eventHandler}
        />
      </>
    );
}
